import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ResponsePackage } from '../models/util.model';
import { Observable } from 'rxjs';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root',
})
export class AiUploadBatchObjectsService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'batchUploadObjects/';
  }

  getSegmentationData(): Observable<any> {
    return this.http.get(`${this.pathApi}getSegmentationData`, {
      headers: this.headers,
      observe: 'response',
    })
  }

  getall(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj, {
      headers: this.headers,
      observe: 'response',
    })
  }
  getMapDetails(id: number) {
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}getMapDetails/${id}`, { headers: this.headers, observe: 'response' });
  }
}